import React from 'react';
import { withRouter } from 'react-router-dom';
import { Navbar } from 'rbx';
import { useStoreActions, useStoreState } from 'easy-peasy';
import PlaceSearchOverlay from './PlaceSearchOverlay';

const Header = ({ history, onClickMenu, location }) => {
  const logout = useStoreActions(state => state.auth.logout);
  const user = useStoreState(state => state.auth.user);
  const [overlayIsOpen, setOverlayIsOpen] = React.useState(false);
  const { defaultPlace } = useStoreState(state => state.menu);

  const showOverlay =
    location.pathname === '/menus' ||
    location.pathname === '/menu-service-settings' ||
    location.pathname === '/menu-sections' ||
    location.pathname === '/menu-Items' ||
    location.pathname === '/menu-modifiers-groups' ||
    location.pathname === '/menu-modifiers-groups' ||
    location.pathname === '/place-deals' ||
    location.pathname === '/add-menu-service-setting' ||
    location.pathname === '/add-menu' ||
    location.pathname === '/add-menu-section' ||
    location.pathname === '/add-menu-item' ||
    location.pathname === '/add-modifiers-group' ||
    location.pathname === '/add-place-deal' ||
    location.pathname === '/upload-menu-items';

  return (
    <>
      {overlayIsOpen && showOverlay && (
        <PlaceSearchOverlay
          isOpen={overlayIsOpen}
          setIsOpen={setOverlayIsOpen}
        />
      )}
      <Navbar color="primary" fixed="top">
        <Navbar.Brand>
          <Navbar.Item onClick={onClickMenu}>
            <i className=" heading is-size-3 has-text-weight-bold fas fa-bars has-text-white" />
          </Navbar.Item>
          <Navbar.Item href="#">
            <p className="heading is-size-3 has-text-weight-bold">Kravein</p>
          </Navbar.Item>
          <Navbar.Burger />
        </Navbar.Brand>
        <Navbar.Menu>
          {/* <Navbar.Segment align="start">
        <Navbar.Item>Home</Navbar.Item>
        <Navbar.Item>Documentation</Navbar.Item>

        <Navbar.Item dropdown>
          <Navbar.Link>More</Navbar.Link>
          <Navbar.Dropdown>
            <Navbar.Item>About</Navbar.Item>
            <Navbar.Item>Jobs</Navbar.Item>
            <Navbar.Item>Contact</Navbar.Item>
            <Navbar.Divider />
            <Navbar.Item>Report an issue</Navbar.Item>
          </Navbar.Dropdown>
        </Navbar.Item>
      </Navbar.Segment> */}

          <Navbar.Segment align="end">
            {showOverlay && (
              <Navbar.Item onClick={() => setOverlayIsOpen(true)}>
                {defaultPlace ? defaultPlace.name : 'Select Default Place'}
              </Navbar.Item>
            )}
            <Navbar.Item
              onClick={() => {
                history.push(`/admin-user-activity/${user.user_id}`);
              }}
            >
              Welcome {user.first_name} {user.last_name}
            </Navbar.Item>

            <Navbar.Item>Change Password</Navbar.Item>
            <Navbar.Item onClick={() => logout(history)}>Sign out</Navbar.Item>
          </Navbar.Segment>
        </Navbar.Menu>
      </Navbar>
    </>
  );
};

export default withRouter(Header);
